import { useRoles } from 'domains/Auth/authSlice/useRoles';

const useGetIsUserFullRole = () => {
  const { validateRoles } = useRoles();

  return validateRoles('full');
};

export default useGetIsUserFullRole;
